import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { layers } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize, borderRadius } from '@atlassian/jira-common-styles/src';

const SIDEBAR_Z_INDEX = 10;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Wrapper = styled.div<{ isResizing: boolean }>({
	display: 'flex',
	flex: 1,
	alignItems: 'stretch',
	height: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	cursor: ({ isResizing }) => (isResizing ? 'ew-resize' : 'default'),
});

export type SidebarProps = { sidebarWidth: number };

/**
 * @deprecated use primitives instead. Remove when cleaning up 'jsw.list.sidebar-layout-update'
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SidebarOld = styled.div<SidebarProps>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: ({ sidebarWidth }) => `${sidebarWidth}px`,
	flexShrink: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	background: token('elevation.surface', colors.N0),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${borderRadius * 2}px ${borderRadius * 2}px 0 0`,
	position: 'relative',
	margin: `${token('space.300', '24px')} ${token('space.300', '24px')} 0 0`,
	boxShadow: token(
		'elevation.shadow.overlay',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		`0px 8px 12px ${colors.N40A}, 0px 0px 1px ${colors.N60A}`,
	),
	zIndex: SIDEBAR_Z_INDEX,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SidebarContent = styled.div({
	overflowY: 'auto',
	/* ⚠️ to accommodate this style we place extra div around SidebarIssueApp and CommentsSidebar */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> div': {
		position: 'absolute',
		top: 0,
		bottom: 0,
		width: '100%',
		padding: `${token('space.100', '8px')} 0`,
	},
	/* Fix for jumping Issue App breadcrumbs on hover. Ideally this should be fixed inside Issue App component */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'nav ol > div': {
		display: 'flex',
		alignItems: 'center',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResizeHandle = styled.div({
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 3}px`,
	cursor: 'ew-resize',
	position: 'relative',
	alignSelf: 'stretch',
	zIndex: layers.blanket(),
	left: token('space.negative.150', '-12px'),
	height: '100%',
	'&::after': {
		content: '',
		background: 'none',
		transition: 'background 0.2s',
		position: 'absolute',
		width: '2px',
		top: 0,
		left: token('space.150', '12px'),
		height: '100%',
	},
	'&:hover::after, &:active::after': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		background: token('color.border.focused', colors.B200),
	},
});
